import { api } from '../../api/Axios';

const register = (values) => {
  const resource = 'manage/register';
  return api.post(resource, values);
};

const checkUniqueEmail = (email) => {
  const resource = 'manage/checkuniqueemail';
  const data = { email };
  return api.post(resource, data);
};
export default { register, checkUniqueEmail };
